import { API as APIConstants } from '../constants/appConstants'
import { API_KEY } from 'environmentConstants'

export function buildAPIBaseURL(url, options = {}) {
  let result = ''
  const defaultOptions = {
    urlPrefix: APIConstants.COMMON,
    companyPrefix: true,
    format: '.json',
    fullURL: false,
    urlParams: {
      token: API_KEY
    }
  }

  options = Object.assign({}, defaultOptions, options)

  if (options.fullURL) {
    result += `${window.location.protocol}//${window.location.host}`
  }

  result += `${options.urlPrefix}/`

  if (options.prefix) {
    result += `${options.prefix}/`
  }

  if (options.companyPrefix) {
    result += `companies/${Tru.Stores.reduxStore.getState().company.id}`
    if (url.length > 0) {
      result += '/'
    }
  }

  result += url

  if (options.format) {
    result += options.format
  }

  if (options.urlParams) {
    result += '?' + $.param(options.urlParams)
  }

  return result
}

export function buildBaseURL(url, options = {}) {
  options = Object.assign({}, options, {
    urlPrefix: APIConstants.BASE,
    format: '',
    urlParams: null
  })

  return buildAPIBaseURL(url, options)
}



// WEBPACK FOOTER //
// ../src/utils/urlHelper.js